module.exports = __webpack_public_path__ + "img/ayoola-full-t.2e4db672.png";